<div  *ngIf="data.type == 'success'">
    <i class="fa fa-check toast-icon success-toast" aria-hidden="true"></i> <span class="success-toast toast-hdr">Success!</span>
    <span class="toast-message">
        {{data.message}}
    </span>
</div>

<div  *ngIf="data.type == 'error'">
    <i class="fa fa-times toast-icon error-toast" aria-hidden="true"></i>  <span class="error-toast toast-hdr">Error!</span>
    <span class="toast-message">
        {{data.message}}
    </span>
</div>